import React from 'react';
import styled from 'styled-components';
import BatchFileInputTable from "./BatchFileInputTable";
import { CountBadge, hw } from "../homeworkUi";

interface BatchFileInputSectionProps {
    accept:string;
    label: string;
    fileList: File[];
    setFileList: React.Dispatch<React.SetStateAction<File[]>>;
}

const BatchFileInputSection = ({accept, label, fileList, setFileList }: BatchFileInputSectionProps) => (
    <View>
        <LabelRow>
            <Label>{label}</Label>
            <CountBadge>{fileList.length}개</CountBadge>
        </LabelRow>
        <BatchFileInputTable accept={accept} fileList={fileList} setFileList={setFileList} />
    </View>
);

const View = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 280px;
    flex-grow: 1;
    min-width: 0;
`;

const LabelRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

const Label = styled.div`
    color: ${hw.text};
    font-size: 13px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export default BatchFileInputSection;
